import React from "react";
import { Link } from "../lib/Link";

export const breadcrumbs = (type, links) => {
  console.log('breadcrumbs', links)
  return (
    <div className="breadcrumbs row middle">
      <Link to="/">TOP</Link>
      {links.map((link, index) => {
        if (!link) {
          return null;
        }
        if (link.href && index !== links.length - 1) {
          return (
            <Link to={link.href} key={index}>
              {link.text}
            </Link>
          );
        } else {
          return <span key={index}>{link.text}</span>;
        }
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/breadcrumbs.jsx